import React, { useMemo } from 'react'
import { useHistory } from 'react-router-dom'
import { useParamsInt } from '../../../../shared/hooks/location'
import { useApiFormAnalyticType } from '../../../../api-new/state/analytics'
import { BreadcrumbView } from '../../../../context/breadcrumb.context'
import { CardFullHeightScrollY } from '../../../../shared/card/card-full-height-scroll-y'
import { IconList } from '../../../../shared/icon/icon'
import { Card } from '../../../../shared/card/card'
import { Form, FormSubmitCancel } from '../../../../shared/form/form'
import { FormTextConfirmPurge } from '../../../../shared/form/form-text-confirm-purge'

export const AnalyticTypePurge = () => {
  const { id } = useParamsInt()

  const history = useHistory()

  const apiFormAnalyticType = useApiFormAnalyticType()

  const handleMatch = () => apiFormAnalyticType.get(`${id}/deleted`)

  const handleSubmit = async data => {
    await apiFormAnalyticType.delete(`${data.id}/purge`)
    history.goBack()
  }

  const handleClose = () => history.goBack()

  const showWarning = useMemo(() => !!apiFormAnalyticType.form.analyticCount, [apiFormAnalyticType])

  return (
    <React.Fragment>
      <BreadcrumbView Icon={IconList} text="Purge" onMatch={handleMatch}>
        <CardFullHeightScrollY title={`Purge ${apiFormAnalyticType.form.name}`}>
          {showWarning &&
            <Card>
              <span className="text-danger">
                This topic has {apiFormAnalyticType.form.analyticCount} analytics attached to it. Purging will remove these and associated data.
              </span>
            </Card>}
          <Form state={apiFormAnalyticType.form} onSubmit={handleSubmit} onRefresh={handleMatch}>
            <Card>
              <FormTextConfirmPurge autoFocus />
              <FormSubmitCancel onCancel={handleClose} />
            </Card>
          </Form>
        </CardFullHeightScrollY>
      </BreadcrumbView>
    </React.Fragment>
  )
}
